import config from 'constants/config'
import useQueryParams from 'hooks/useQueryParams'

export default function useIsLoginV2Enabled(): boolean {
  const query = useQueryParams()
  return !!config.BUSINESS_TRAVELLER_LOGIN_V2_ENABLED && query.get('login-v2') === 'true'
}
